export const CORE_VALUES_TYPE = 'core_values';
export const INNOVATION_TYPE = 'innovation';
export const ROBOT_DESIGN_TYPE = 'robot_design';

export const FLL_CHALLENGE_JUDGING_EXPORT_TYPES = [
  CORE_VALUES_TYPE,
  INNOVATION_TYPE,
  ROBOT_DESIGN_TYPE
]